import moment from 'moment';

const isNotValidValue = (value) => {
    return (value === null || value === undefined || value === "-9999999999999" || value === "NaN" 
        || value === "--" || value === "" || value.toLocaleString() == 'NaN' || value === "N/A" || value === "-");
}

const numberFormatter = (value) => {
    const decimalCount = 2; // Default decimal count
    if (isNotValidValue(value)) {
        return 0.00;
    }

    return (Math.round(value * (10 ** decimalCount)) / (10 ** decimalCount)).toLocaleString(undefined,{minimumFractionDigits: decimalCount,maximumFractionDigits:decimalCount})
}

const dateFormatter = (value) => {
    if(value){
        let date = moment(value);
        return dateFormatterForUI(date);
    }else{
        // Returning hyphen when value id undefined else it will be a new Date
        return "--";
    }    
}

const standardDateFormatter = () => {
    return (getDateFormat() === 'DD/MM/YYYY' ? "D/M/YYYY" : "M/D/YYYY");
}

const dateFormatterForUI = (param) => {
    if(param){
        const dateStr = typeof(param) === 'string' ? param : moment(param)?.format('YYYY-MM-DD');
        return moment.utc(dateStr).format(standardDateFormatter());
    }
}

export const getFormattedValue = (value, type) => {
    if (type === 'Num' || type ==='Err') {
        return numberFormatter(value);
    } else if (type === 'date') {
        return dateFormatter(value);
    } else if (type === 'string') {
        return value;
    } else {
        return value;
    }
}

export const getCurrencySymbol = (currencyCode, withParenthesis) => {
    if (!currencyCode) {
        return '';
    } else if(currencyCode === 'All') {
        return withParenthesis ? '(Account Specific)': 'Account Specific';
    }
    return withParenthesis ? `(${currencyCode})` : currencyCode;
}